
import Vue from 'vue'
import { VBreadcrumbs } from 'vuetify/lib'
import { breadcrumb } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcBreadcrumbsVue',
  components: {
    VBreadcrumbs,
  },
  props: {
    extHomeUrl: { type: String, default: undefined },
  },
  computed: {
    breadcrumbs(): Array<breadcrumb | undefined> {
      const path = this.$route,
        breadcrumbs = path.matched.map((x) => {
          return {
            to: x.path ? { name: x.name } : x.redirect,
            text: x.meta.breadCrumb ? x.meta.breadCrumb : x.name,
            href: this.extHomeUrl ? this.extHomeUrl : undefined,
            disabled: x.components.default.name === undefined,
          }
        })
      if (breadcrumbs[0].text === breadcrumbs[1].text) breadcrumbs.shift()
      return breadcrumbs
    },
  },
})
